import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'

export default {
  name: 'bag-in-shipment-live-response',
  components: {VueElementLoading},
  props: [],
  data () {
    return {
      isLoading: false,
      sublist:false,
      isShippingIdError: 0,
      ShippingIdError: '',
      shippingId:'',
      createdAt:'',
      createdBy:'',
      shipmentDetailsForNew:[],
      responseDetails:[]
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == '' || date == null) {
        return '--'
      }
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted () {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
  },
  methods: {
    getShipmentDetails() {
      this.sublist = false,
      this.shipmentDetailsForNew=[]
      this.responseDetails=[]
      this.createdAt=''
      this.createdBy=''
      if (this.shippingId == '') {
        this.isShippingIdError = '1',
        this.ShippingIdError = 'The Shipping Id field is required.'
        return false;
      } else {
        this.isShippingIdError = '',
        this.ShippingIdError = ''
      }
      this.isLoading = true
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getHubInScanLogForShipmentBhiwandiSorter/'+ self.shippingId.trim(),
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false
            this.sublist = true
            for(var i=0;i<result.data.ResponseData.length;i++){
              let value={}
              this.shipmentDetailsForNew.push(result.data.ResponseData[i].requestData)
              value.shippingId=result.data.ResponseData[i].shippingId;
              value.createdAt=result.data.ResponseData[i].createdAt;
              value.createdBy=result.data.ResponseData[i].createdBy;
              value.responseData=result.data.ResponseData[i].responseData;
              this.responseDetails.push(value)

            }
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.isLoading = false
          }
        }, error => {
          console.error(error)
        })
    },
    clearError(){
      if (this.shippingId == '') {
        this.isShippingIdError = '1',
        this.ShippingIdError = 'The Shipping Id field is required.'
      } else {
        this.isShippingIdError = '',
        this.ShippingIdError = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BhiwandiSorter/hubInscanLogs/hubInscanLogs.js